// In this project there are unfortunately two jQuerys
// `window.$` references v1.11.0
// `window.jQuery` references v3.4.1

export default window.jQuery;
